import { Box, Chip as BaseChip, chipClasses, styled } from "@mui/material";

export const Container = styled(Box)`
  container: new-market-lens-container / inline-size;
`;

export const Chip = styled(BaseChip)`
  min-width: 20px;
  width: 20px;
  height: 20px;
  font-size: ${({ theme }) => theme.typography.size.small};
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};

  & .${chipClasses.label} {
    padding: 0;
  }
`;

export const FormRow = styled(Box)`
  max-width: 380px;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(4)};

  @container new-market-lens-container (width < 400px) {
    /* list the bullet points above the form on very small screens */
    flex-direction: column-reverse;
  }
`;
